import createGenericContext from '@utils/createGenericContext';
import type { Dispatch, SetStateAction } from 'react';

export type SocketLockStatusItem = {
  isLocked: boolean;
  lockedBy: string;
  userId: number | null;
  userName: string | null;
  isStandingOrderRide: boolean;
  type: string;
};

export type SocketLockStatus = Record<string, SocketLockStatusItem>;

export type UnlockResolvedSegment = {
  segmentId: number | string;
  ts: number;
} | null;

export type LyftContextType = {
  setSocketStatus: (props: any) => void;
  removeStatusById: (segmentId: number) => void;
  socketStatus: any;
  socketLockStatus: SocketLockStatus;
  socketContractorStatus: any;
  setSocketLockStatus: Dispatch<SetStateAction<SocketLockStatus>>;
  setSocketContractorStatus: Dispatch<SetStateAction<any>>;
  unlockResolvedSegment: UnlockResolvedSegment;
  setUnlockResolvedSegment: Dispatch<SetStateAction<UnlockResolvedSegment>>;
};

export const [LyftContext, LyftContextProvider] =
  createGenericContext<LyftContextType>('LyftContext');
